import useLocalStorageState from "use-local-storage-state";
import useCurrentUser from "./useCurrentUser";

const CHARTS_KEY = "charts";

const DEFAULTS: {
  type: "bar" | "line";
  zoom: {
    [x: string]: {
      start: number;
      end: number;
    };
  };
} = {
  type: "bar",
  zoom: {
    "latest-transactions-chart": {
      start: 0,
      end: 20,
    },
    "month-chart": {
      start: 0,
      end: 20,
    },
    "categories-chart": {
      start: 0,
      end: 20,
    },
    "client-provider-chart": {
      start: 0,
      end: 20,
    },
    "payment-methods-chart": {
      start: 0,
      end: 20,
    },
    "attachment-types-chart": {
      start: 0,
      end: 20,
    },
  },
};

export default function useCharts() {
  const { userInfo } = useCurrentUser();

  const [chartPreferences, setChartPreferences] = useLocalStorageState(
    `${userInfo?._id}-${CHARTS_KEY}`,
    { defaultValue: DEFAULTS }
  );

  return {
    chartPreferences,
    updateChart: (newState: Partial<typeof DEFAULTS>) => {
      setChartPreferences((prev: any) => ({ ...prev, ...newState }));
    },
    updateZoom: (chartId: string, start: number, end: number) => {
      setChartPreferences((prev: any) => ({
        ...prev,
        zoom: {
          ...prev.zoom,
          [chartId]: { start, end },
        },
      }));
    },
  };
}
